import type { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const drawerWidth = 300;

export default makeStyles<Theme>((theme: Theme) => ({
  containerWrapper: {
    height: `calc(100vh - ${theme.mixins?.denseToolbar?.minHeight || 72}px)`,
  },
  container: {
    height: '100%',
    overflow: 'auto',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    willChange: 'margin',
    marginLeft: drawerWidth
  },
  container_sidebar_closed: {
    marginLeft: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(12)
    }
  }
}));
